import gql from 'graphql-tag';

export const UPDATE_LOOK_VERTICAL_FILTER = gql`
  mutation updateLookVerticalFilter($filter: VerticalFilterInput!, $orderBy: [String]) {
    updateLookVerticalFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
